module.exports = __webpack_public_path__ + "static/media/HankenSvenskaHandelshogskolan.75b4f1c5.webp";